/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { Redirect, Route, Switch } from 'react-router-dom';
import { ADMIN_BEARER_NAME, ADMIN_ROUTES } from '../../util/vars';
import React from 'react';
import LoginPageComponent from './Login/LoginPageComponent';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { useLocalStorage } from 'react-use';
import WeeklyLeadersEmailsPageComponent from './WeeklyLeadersEmails/WeeklyLeadersEmailsPageComponent';

export default function Routes() {
  const [ adminBearer ] = useLocalStorage<string | null>(ADMIN_BEARER_NAME, null, { raw: true });

  return (
    <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_AUTH_CLIENT_ID!}>
      <Switch>
        <Route path={ADMIN_ROUTES.weeklyLeadersEmails}>
          {null != adminBearer
            ? (
              <WeeklyLeadersEmailsPageComponent />
            )
            : (
              <Redirect to={ADMIN_ROUTES.login} />
            )}
        </Route>
        <Route>
          {null == adminBearer
            ? (
              <LoginPageComponent />
            )
            : (
              <Redirect to={ADMIN_ROUTES.weeklyLeadersEmails} />
            )}
        </Route>
      </Switch>
    </GoogleOAuthProvider>
  );
}
